/* eslint-disable no-case-declarations */
import { isValidUrl } from 'lib/isValidUrl';
import { Node, Text, Element as SlateElement } from 'slate';
import { RenderElementProps, RenderLeafProps } from 'slate-react';

export const Element = ({
  attributes,
  children,
  element,
}: RenderElementProps) => {
  switch (element.type) {
    case 'link':
      return (
        <a {...attributes} href={element.url}>
          {children}
        </a>
      );
    default:
      return <p {...attributes}>{children}</p>;
  }
};

export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }
  if (leaf.strikethrough) {
    children = <s>{children}</s>;
  }

  return <span {...attributes}>{children}</span>;
};

export const renderReactElements: any = (node: Node, index?: number) => {
  if (Text.isText(node)) {
    const string = node.text;
    let element = <span key={index}>{string}</span>;
    if (node.bold) {
      element = <strong key={index}>{element}</strong>;
    }
    if (node.italic) {
      element = <em key={index}>{element}</em>;
    }
    if (node.underline) {
      element = <u key={index}>{element}</u>;
    }
    if (node.code) {
      element = <code key={index}>{element}</code>;
    }
    if (node.strikethrough) {
      element = <s key={index}>{element}</s>;
    }
    return element;
  }

  const children = node.children.map((n, i) => renderReactElements(n, i));
  if (SlateElement.isElement(node)) {
    switch (node.type) {
      case 'paragraph':
        return <p key={index}>{children}</p>;
      case 'link':
        if (isValidUrl(node.url)) {
          return (
            <a key={index} href={node.url}>
              {children}
            </a>
          );
        } else {
          // if the link does not pass sanitization, lets not pass it to our users.
          return <span key={index}>{children}</span>;
        }
      default:
        return children;
    }
  }
};
